export enum DRAG_ITEM_TYPES {
  CUSTOM_REPORT = 'customReport',
  DATALINE = 'dataline',
  DATALINE_ELEMENT = 'datalineElement',
  ORG_UNIT = 'orgUnit',
  SHAPING = 'shaping',
  VARIABLE = 'variable',
}
